import moment from 'moment-timezone';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { DATE_TIME_FORMAT } from '../../../constants';
import { deleteAidentifiedUpload } from '../../../services/aidentifiedDataApi';
import { BasicModal, Button, ModalHeader } from '../../Shared';

export const DeleteUploadModal = ({ upload, onClose, onDeleted }) => {
  const { importId, fileName, tenantName, uploadedOn, rowsMatched } = upload;

  const [isSubmitting, setIsSubmitting] = useState(false);

  const onDelete = async () => {
    setIsSubmitting(true);

    try {
      await deleteAidentifiedUpload(importId);
      toast.success(`Upload deleted: ${fileName}.`, {
        position: 'top-right',
        autoClose: 3000,
      });
      onDeleted(importId);
    } catch {
      setIsSubmitting(false);
      toast.error('Failed to delete the upload!', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  return (
    <BasicModal open onClose={isSubmitting ? undefined : onClose}>
      <div className="bg-white w-[520px] rounded-2xl shadow-[-40px_40px_80px_-8px_rgba(0,0,0,0.24)]">
        <ModalHeader
          title="Delete this upload?"
          subtitle={`${fileName} · ${tenantName} · ${moment(uploadedOn).format(DATE_TIME_FORMAT.MM_DD_YYYY_hh_mm_A)}`}
          disabled={isSubmitting}
          onClose={onClose}
        />
        <p className="px-5 pb-2 text-base-1000 text-[16px]/[24px]">
          The {rowsMatched.toLocaleString('en-US')} lead records from this
          upload are removed. Leads that have data from an earlier upload go
          back to it. Leads with no other upload get the current web-based
          customization.
        </p>
        <div className="flex items-center justify-end gap-3 py-4 px-5">
          <Button
            type="button"
            title="Cancel"
            variant="text"
            disabled={isSubmitting}
            onClick={onClose}
          />
          <Button
            type="button"
            title="Delete upload"
            variant="error"
            disabled={isSubmitting}
            onClick={onDelete}
          />
        </div>
      </div>
    </BasicModal>
  );
};
